import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentTermsAndConditions = {
  ID: number
  published_date: string
  current_version: number
  url: string
}

export function getEnrollmentTermsAndConditions(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getTermsAndConditions.url, { id: enrollmentId }))
    .get<EnrollmentTermsAndConditions>()
}
